/**
 * Util function for calculating the index of the thumb that is closes to a given position
 * @param thumbs - array of Thumb element to calculate the distance from
 * @param clientX - target x position (pointer)
 */
export function getClosestThumbIndex(
  thumbs: Element[],
  clientX: number,
) {
  let thumbIndex = 0
  let minThumbDistance = getThumbDistance(thumbs[0], clientX)
  for (let i = 1; i < thumbs.length; i++) {
    const thumbDistance = getThumbDistance(thumbs[i], clientX)
    if (thumbDistance < minThumbDistance) {
      minThumbDistance = thumbDistance
      thumbIndex = i
    }
  }
  return thumbIndex
}

// =============
// Local Helpers
// =============

/**
 * Util function for calculating the distance of the center of a thumb
 * from a given pointer target's position
 * @param thumbEl - Thumb element to calculate the distance from
 * @param clientX - target x position (pointer)
 */
function getThumbDistance(
  thumbEl: Element,
  clientX: number,
) {
  const { left, width: thumbWidth } = thumbEl.getBoundingClientRect()
  return Math.abs(clientX - (left + thumbWidth / 2))
}
